import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { ScrollArea } from '../ui/scroll-area';
import { MethodBadge } from './MethodBadge';
import { Loader2, CheckCircle2, XCircle, History } from 'lucide-react';

export const ExecutionLogsDialog = ({ open, onOpenChange, logs, loading }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <History className="h-5 w-5" />
            Historial de Ejecuciones
          </DialogTitle>
        </DialogHeader>
        
        <ScrollArea className="flex-1">
          {loading ? (
            <div className="flex justify-center py-8">
              <Loader2 className="h-6 w-6 animate-spin" />
            </div>
          ) : logs.length > 0 ? (
            <div className="space-y-3">
              {logs.map(log => (
                <Card key={log.id}>
                  <CardContent className="p-3">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center gap-2">
                        {log.success ? (
                          <CheckCircle2 className="h-4 w-4 text-green-500" />
                        ) : (
                          <XCircle className="h-4 w-4 text-red-500" />
                        )}
                        <MethodBadge method={log.request_method} />
                        <span className="text-sm font-mono truncate max-w-md">{log.request_url}</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-500">
                        <span>{log.response_time_ms}ms</span>
                        <Badge variant="outline">{log.response_status || 'N/A'}</Badge>
                      </div>
                    </div>
                    <div className="text-xs text-gray-400">
                      {new Date(log.executed_at).toLocaleString()}
                      {log.error_message && (
                        <span className="text-red-500 ml-2">{log.error_message}</span>
                      )}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : (
            <p className="text-center text-gray-500 py-8">Sin ejecuciones registradas</p>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default ExecutionLogsDialog;
